import { Link } from 'react-router-dom';
import { Info } from 'lucide-react';
import { MarketplaceArche } from '@/lib/api';

interface ArcheSidebarItemProps {
  arche: MarketplaceArche;
  isActive: boolean;
}

export function ArcheSidebarItem({ arche, isActive }: ArcheSidebarItemProps) {
  return (
    <div
      className={`
        px-3 py-3 mx-2 min-h-[44px]
        border-b border-border last:border-b-0
        transition-colors duration-150
        ${isActive
          ? 'bg-primary/10 text-primary'
          : 'hover:bg-muted text-foreground'
        }
      `}
    >
      <Link
        to={`/a/${arche.archId}`}
        className="block"
      >
        <div className="font-medium text-sm line-clamp-2">
          {arche.name}
        </div>
        <div className="text-xs text-muted-foreground line-clamp-3 mt-1">
          {arche.simpleDescription}
        </div>
      </Link>

      <Link
        to={`/marketplace/arches/${arche.archId}`}
        className="inline-flex items-center gap-1 mt-2 py-1 px-2 -ml-2 text-xs text-muted-foreground hover:text-foreground hover:bg-muted rounded transition-colors min-h-[32px]"
      >
        <Info className="h-3 w-3" />
        <span>Info</span>
      </Link>
    </div>
  );
}

export default ArcheSidebarItem;
